<template>
  <a
    :class="{active}"
    :href="path"
    class="menu-item"
    @click.prevent="onClick">
    Main
  </a>
</template>

<script>
export default {
  data() {
    return {
      path: '/main'
    };
  },
  computed: {
    active() {
      return this.path === this.$store.path;
    }
  },
  methods: {
    onClick() {
      this.$store.navigate(this.path, {});
    }
  }
};
</script>
